export default function Locations({ locations, handleLocation }){
    return(
        <div className="col-md-9 mx-auto">
            <h3 className="section-heading">Offline Locations</h3>
            <div className={`course-location-content ${locations?.length >=3 ? 'grid-type-3' : `grid-type-${locations?.length}`}`}>
                {locations?.map((element, index) => (
                    <div className="location-card" key={index}>
                        <h3 className="heading">{element?.city}</h3>
                        <p className="place">{element?.address}</p>
                        <div className="desc">
                            <div className="left">
                                <p className="office">{element?.landmark}</p>
                            </div>
                            <button className="right" onClick={()=> handleLocation(element?.city)}>
                                <span>View More</span>
                                <img src="https://media.geeksforgeeks.org/img-practice/prod/courses/1/Web/Content/arrow-right_1689245081.svg" alt="Arrow"/>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
         
    )
}